import { Component, inject, OnInit } from '@angular/core';
import { PriceService, GungFlowService, AuthService, SelectedCustomerService, ProductAssortmentParentService, Product } from 'gung-standard';
import { OttoOlsenProductGridViewComponent } from '../otto-olsen-product-grid-view/otto-olsen-product-grid-view.component';
import { first } from 'rxjs';
import { OttoOlsenProductAssortmentParentService } from '../../services/otto-olsen-product-assortment-parent.service';

@Component({
  selector: 'otto-olsen-favourite-product-grid-view',
  templateUrl: './otto-olsen-favourite-product-grid-view.component.html',
  styleUrls: ['./otto-olsen-favourite-product-grid-view.component.scss'],
  standalone: false
})
export class OttoOlsenFavouriteProductGridViewComponent extends OttoOlsenProductGridViewComponent {
  protected ottoOlsenProductAssortmentParentService = inject(OttoOlsenProductAssortmentParentService);

  goToDetail(product: Product): void {
    if (product.productType === 'concept') {
      this.router.navigate(['/concept', product.id]);
    } else {
      this.ottoOlsenProductAssortmentParentService.postProductAssortmentParentByProductIds([product.id]).pipe(first()).subscribe(element => {
        let path: string[] = structuredClone(element[product.id]).map(p => p.id);
        path.splice(0, 1, '/articles');
        path.push(product.id);
        this.router.navigate([...path]);
      });
    }
  }
}
